const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3354 2.67083C18.7059 2.48559 18.8561 2.03509 18.6708 1.6646C18.4856 1.29412 18.0351 1.14395 17.6646 1.32919L8.75 5.78648V4.25H3.25V8.53648L1.66459 9.32919C1.2941 9.51443 1.14393 9.96494 1.32918 10.3354C1.51442 10.7059 1.96492 10.8561 2.33541 10.6708L3.25 10.2135V20.25H2C1.58579 20.25 1.25 20.5858 1.25 21C1.25 21.4142 1.58579 21.75 2 21.75H3.25H16.75H22C22.4142 21.75 22.75 21.4142 22.75 21C22.75 20.5858 22.4142 20.25 22 20.25H20.75V14.8107L21.4697 15.5303C21.7626 15.8232 22.2374 15.8232 22.5303 15.5303C22.8232 15.2374 22.8232 14.7626 22.5303 14.4697L16.75 8.68934V3.46354L18.3354 2.67083ZM7.25 20.25H4.75V9.46354L15.25 4.21354V20.25H12.75V13.25H7.25V20.25ZM8.75 20.25H11.25V14.75H8.75V20.25ZM19.25 20.25H16.75V10.8107L19.25 13.3107V20.25ZM4.75 7.78648L7.25 6.53648V5.75H4.75V7.78648Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.714cbb868d7c6ff1057a8e577b6aba23.svg";
export { ForwardRef as ReactComponent };